import { fetchScheduleTemplateDetail } from "@api/scheduleTemplate.api";
import { scheduleAccrualHoldingAccountId } from "@common/helpers/splitRuleAction";
import { ScheduleTemplateListItem } from "@common/schemas/domains/accounting/scheduleTemplate.schema";

export interface SplitScheduleHoldingPatch {
    accrualAccountId?: string;
    entityId?: number;
}

export async function resolveSplitScheduleHolding(params: {
    template: ScheduleTemplateListItem;
    entityId?: number;
    workspaceId: string | null | undefined;
}): Promise<SplitScheduleHoldingPatch> {
    let accountRows = params.template.accountRows;
    let holdingAccountId = scheduleAccrualHoldingAccountId({
        accountRows,
        entityId: params.entityId,
    });
    if (!holdingAccountId && params.workspaceId) {
        const detail = await fetchScheduleTemplateDetail({
            workspaceId: params.workspaceId,
            id: params.template.id,
        });
        accountRows = detail.accountRows;
        holdingAccountId = scheduleAccrualHoldingAccountId({
            accountRows,
            entityId: params.entityId,
        });
    }

    const uniqueEntityIds = [
        ...new Set(
            params.template.entityIds.length > 0
                ? params.template.entityIds
                : accountRows.map((row) => row.entityId),
        ),
    ];
    const entityId =
        params.entityId === undefined && uniqueEntityIds.length === 1
            ? uniqueEntityIds[0]
            : undefined;

    return {
        accrualAccountId: holdingAccountId,
        entityId,
    };
}
